export default {
  login: {
    signin: 'Se connecter',
    signout: 'Se déconnecter',
    login: 'Connexion',
    forgotpassword: 'Mot de passe oublié ?',
    forgotidentifiant: 'Identifiant oublié ?',
    assistance: 'Assistance',
    id: 'Identifiant',
    idParticulier:
      'Vous pouvez vous authentifier avec votre: Adresse mail, numéro de portable ou votre numéro participant',
    idCorrespondant: 'Veuillez saisir votre adresse mail',
    password: 'Mot de passe',
    identifiantParticipant: 'Identifiant Participant',
    tentative: {
      1: 'Mot de passe incorrect. Il vous reste 2 tentatives',
      2: "Mot de passe incorrect. Ceci est votre dernière tentative, votre compte sera bloqué en cas d'erreur",
      3: 'Votre compte est verrouillé, veuillez contacter le CIEM',
    },
    invalid_grant: 'Identifiant utilisateur incorrect',
  },
}
